import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../index';

import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

export const EVENT_IDS = {
  VIEW_GENERATED_LEASE: '8119',
} as const;

// https://dataportal.zillowgroup.net/event-registry/8119
export const emitViewGeneratedLeaseEvent = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '283',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.VIEW_GENERATED_LEASE,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_property_overview',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'view_lease',
    },
    semantic: {
      semantic_event_nm: 'click_view_lease',
      topic_tag_txt: [],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });
